const API_ROOT = process.env.REACT_APP_API_BASE || '/api';

export function logAction(message, level = 'INFO') {
  if (typeof console !== 'undefined') {
    console.log(`[${level}] ${message}`);
  }
  fetch(`${API_ROOT}/logs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ level, message }),
  }).catch(() => {});
}
